import { useEffect, useState } from "react";
import HeaderLogo from "../components/HeaderLogo";
import PageName from "../components/PageName";
import { useSelector } from "react-redux";
import Svg from "../components/figs/Svg";
import {
  base64ToUint8Array,
  convertReportToTableCustomerListReport,
  convertReportToTableInsuracneReport,
  convertReportToTableRegister,
  fetchAuthPost,
  getImageDimensions,
  getImageWithAspectRatio,
  reduceRepeatElement,
  timestampFilename,
  timeToYYYYMMDD,
  yyyymmddd_ddmmyyyy_v1,
} from "../functions/functions";
import api from "../routes/api";
import { useAlertModal } from "../hooks/useAlertModal";
import Loading from "../components/Loading";
import { useToast } from "../hooks/useToast";
import { useForm } from "react-hook-form";
import useSelect from "../hooks/useSelect";
import pdfMake from "pdfmake/build/pdfmake";
import { base64 } from "../consts/base64";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { PDFDocument, rgb } from "pdf-lib";
import * as fontkit from "fontkit";
import LoadingOnTop from "../components/LoadingOnTop";
import useStaticData from "../hooks/useStaticData";

export default function Report() {
  const [isLoading, setIsloading] = useState(true);
  const [isLoadingOnTop, setIsloadingOnTop] = useState(false);
  const { msg } = useSelector((s) => s.language);
  const { alert, AlertModal } = useAlertModal();
  const { showToast, Toasts } = useToast();

  const [table, setTable] = useState([]);
  const [filteredTable, setFilteredTable] = useState(null);

  // const {
  //   register,
  //   setValue,
  //   trigger,
  //   handleSubmit,
  //   watch,
  //   getValues,
  //   reset,
  //   formState: { errors },
  // } = useForm();
  const _data = useForm();

  const [onControlSelectDate, SelectDate] = useSelect();
  const [onControlSelectTourName, SelectTourName] = useSelect();
  const [onControlSelectBoatName, SelectBoatName] = useSelect();

  const _report_type = _data.watch("_report_type");
  const _report = _data.watch("_report");

  const initSetup = async () => {
    try {
      setIsloading(true);
      await fetchAuthPost(api.utils.activeDateList).then((r) => {
        const { active_date_list } = r.data;
        const activeDateOption = active_date_list
          .map((el) => ({
            value: el,
            label: yyyymmddd_ddmmyyyy_v1(el),
            time: new Date(el),
          }))
          .sort((a, b) => b.time - a.time)
          .map((el) => ({ value: el.value, label: el.label }));
        onControlSelectDate.className("max-w-[10rem] w-full");
        onControlSelectDate.placeholder(msg.date);
        onControlSelectDate.option(activeDateOption);
        onControlSelectDate.multiple(false);
        onControlSelectDate.disabledAddNewOption(true);
        _data.setValue("_dateOption", activeDateOption);
      });
      _data.setValue("_report_type", "customer_list_report");
      onControlSelectTourName.className("max-w-[14rem] w-full");
      onControlSelectTourName.placeholder(msg.tour_name);
      onControlSelectTourName.multiple(false);
      onControlSelectTourName.disabledAddNewOption(true);
      onControlSelectBoatName.className("max-w-[14rem] w-full");
      onControlSelectBoatName.placeholder(msg.boat_name);
      onControlSelectBoatName.disabledAddNewOption(true);
    } catch (error) {
      console.error(error);
      alert(msg.alert, error.msg);
    } finally {
      setIsloading(false);
    }
  };

  const onFilterPassenger = (event) => {
    const value = event.target.value;
    let temp = table;
    if (value) {
      temp = temp.filter((el) => {
        return (
          `${el.agent}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.firstname}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.lastname}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.gender}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.age}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.id_passport_no}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.country}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.nationality}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.boat}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.team}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.voucher_no}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.hotel}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.group_id}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.checkin_no}`.toLowerCase().includes(value.toLowerCase())
        );
      });
      setFilteredTable(temp);
    } else {
      setFilteredTable(null);
    }
  };

  useEffect(() => {
    initSetup();
  }, []);

  const fetchTourListByActiveDate = async () => {
    const _active_date = onControlSelectDate.getSelectedOption[0].value;
    const option = await fetchAuthPost(api.utils.tourListByActiveDate, {
      data: { active_date: _active_date },
    }).then((r) =>
      r.data.tour_list.map((el) => ({
        value: +el.id_tour,
        label: el.tour_name,
      }))
    );
    onControlSelectTourName.option(option);
    _data.setValue("_tourOption", option);
    onControlSelectTourName.setSelectedOption([]);
  };

  useEffect(() => {
    onControlSelectTourName.setOption([]);
    onControlSelectTourName.setSelectedOption([]);
    if (onControlSelectDate.getSelectedOption.length > 0) {
      fetchTourListByActiveDate();
    }
  }, [onControlSelectDate.getSelectedOption]);

  const fetchBoatListByActiveDateAndIdTourList = async () => {
    const _active_date = onControlSelectDate.getSelectedOption[0].value;
    const _id_tour_list = onControlSelectTourName.getSelectedOption.map(
      (el) => +el.value
    );
    await fetchAuthPost(api.utils.boatListByActiveDateAndIdTourList, {
      data: { active_date: _active_date, id_tour_list: _id_tour_list },
    }).then((r) => {
      const temp = r.data.boat_list.map((el) => ({
        value: el.id_boat,
        label: el.boat_name,
      }));
      onControlSelectBoatName.setOption(temp);
      _data.setValue("_boatOption", temp);
      onControlSelectBoatName.setSelectedOption([]);
    });
  };

  useEffect(() => {
    onControlSelectBoatName.setOption([]);
    onControlSelectBoatName.setSelectedOption([]);
    if (onControlSelectTourName.getSelectedOption.length > 0) {
      fetchBoatListByActiveDateAndIdTourList();
    }
  }, [onControlSelectTourName.getSelectedOption]);

  const fetchReadReport = async () => {
    setIsloadingOnTop(true);
    const response = await fetchAuthPost(api.report.readReport, {
      data: {
        date: onControlSelectDate.getSelectedOption[0].value,
        id_tour: onControlSelectTourName.getSelectedOption.map(
          (el) => +el.value
        )[0],
        id_boat_list: onControlSelectBoatName.getSelectedOption.map(
          (el) => +el.value
        ),
      },
    });

    const tempReport = response.data;
    const report = await Promise.all(
      tempReport.map(async (element) => {
        const filePath = element?.signature_image_filepath;
        let tempSignatureBase64;
        if (filePath) {
          const res = await fetchAuthPost(
            api.utils.getImageUriByImageUrlInGcs,
            { imageUrl: filePath }
          );
          tempSignatureBase64 = res.data;
        }
        return { ...element, signature_base64: tempSignatureBase64 };
      })
    );

    // กำหนดจำนวน concurrent สูงสุด
    const MAX_CONCURRENT = 5;

    // ฟังก์ชันช่วยจัดการ concurrent
    async function fetchWithLimit(items, handler, limit) {
      const results = [];
      const executing = [];

      for (const item of items) {
        const p = handler(item);
        results.push(p);

        // เพิ่ม promise เข้า array ที่กำลังทำงาน
        executing.push(p);

        if (executing.length >= limit) {
          // รอให้ promise ตัวใดตัวหนึ่งเสร็จ
          await Promise.race(executing);
          // ลบตัวที่เสร็จแล้วออก
          executing.splice(
            0,
            executing.length,
            ...executing.filter((e) => !e.isFulfilled)
          );
        }
      }

      return Promise.all(results);
    }

    // wrapper สำหรับ fetch image
    // async function handleElement(element) {
    //   console.log(element);
    //   const signature_image_filepath = element.signature_image_filepath;
    //   if (signature_image_filepath) {
    //     const res = await fetchAuthPost(api.utils.getImageUriByImageUrlInGcs, {
    //       imageUrl: signature_image_filepath,
    //     });
    //     return { ...element, signature_base64: res.data };
    //   } else {
    //     return element;
    //   }
    // }

    // ใช้งาน
    // const report = await fetchWithLimit(
    //   tempReport,
    //   handleElement,
    //   MAX_CONCURRENT
    // );

    _data.setValue("_report", report);
    if (_report_type === "customer_list_report") {
      const _table = convertReportToTableCustomerListReport(report);
      setTable(_table);
    } else if (_report_type === "register") {
      const _table = convertReportToTableRegister(report);
      setTable(_table);
    } else if (_report_type === "insurance_report") {
      const _table = convertReportToTableInsuracneReport(report);
      setTable(_table);
    }
    const _report_0 = report[0];

    _data.setValue(
      "_subtitle1",
      `${msg.tour_name}: ${_report_0.tour_name} , ${_report_0.trip_duration}`
    );
    _data.setValue("_subtitle2", `${msg.boat_name}: ${_report_0.boat}`);
    _data.setValue(
      "_subtitle3",
      `${msg.date}: ${yyyymmddd_ddmmyyyy_v1(
        _report_0.date || _report_0.departure_date
      )}`
    );
    setIsloadingOnTop(false);
  };

  useEffect(() => {
    if (_report) {
      if (_report_type === "customer_list_report") {
        const _table = convertReportToTableCustomerListReport(_report);
        setTable(_table);
      } else if (_report_type === "register") {
        const _table = convertReportToTableRegister(_report);
        setTable(_table);
      } else if (_report_type === "insurance_report") {
        const _table = convertReportToTableInsuracneReport(_report);
        setTable(_table);
      }
      setFilteredTable(null);
      _data.setValue("_filter", "");
    }
  }, [_report_type]);

  useEffect(() => {
    if (
      onControlSelectDate.getSelectedOption[0]?.value &&
      onControlSelectTourName.getSelectedOption.length > 0 &&
      onControlSelectBoatName.getSelectedOption.length > 0
    ) {
      fetchReadReport();
    } else if (onControlSelectBoatName.getSelectedOption.length === 0) {
      setTable([]);
    }
  }, [onControlSelectBoatName.getSelectedOption]);

  if (isLoading) return <Loading />;
  return (
    <div className="page_report">
      <HeaderLogo />
      <PageName titleName={msg.report} />
      <div className="container-report">
        <div className="content-report">
          {/* row 1 */}
          <div></div>
          {/* row 2 */}
          {/* <div className="flex flex-wrap gap-3 justify-between items-center mt-8 border-b border-[var(--soft-44)] pb-4"> */}
          <div className="content-report-header">
            <span className="text-[1.2rem] font-bold text-[var(--primary)]">
              <span>{msg.report_type}</span>
              <select
                className="_select_1 w-fit ml-4"
                {..._data.register("_report_type")}
              >
                <option
                  value="customer_list_report"
                  label={msg.customer_list_report}
                />
                <option value="register" label={msg.register} />
                <option value="insurance_report" label={msg.insurance_report} />
              </select>
            </span>
            <span className="flex gap-x-2 items-center">
              <span className="relative border border-[var(--soft-44)] rounded-full px-4 py-2">
                <input
                  className="px-2 outline-none text-[var(--primary)]"
                  placeholder={msg.search}
                  {..._data.register("_filter", {
                    onChange: onFilterPassenger,
                  })}
                />
                <span className="absolute right-4 top-1/2 -translate-y-1/2 flex justify-center items-center">
                  <Svg iconName="search" className="size-4" />
                </span>
              </span>
              {table.length > 0 && (
                <span className="download_report">
                  <button className="bg-[var(--primary)] text-[var(--bright)] px-4 py-2 rounded-full font-semibold">
                    {msg.download}
                  </button>
                  <div className="download_option">
                    <ButtonDownloadPdf
                      reportType={_report_type}
                      reportData={_report}
                    />
                    <ButtonDownloadExcel
                      label={msg.excel}
                      bgBase64={base64.logoImgJpg}
                      reportType={_report_type}
                      reportData={_report}
                    />
                  </div>
                </span>
              )}
            </span>
          </div>
          {/* row 3 */}
          <div className="content-report-filter">
            {SelectDate}
            {SelectTourName}
            {SelectBoatName}
          </div>
          {/* row 4 */}
          <div className="container-report-table">
            {_report_type === "customer_list_report" && (
              <section className="table_container_customer_list_report">
                <div className="table_header">
                  <div>{msg.no}</div>
                  <div>{msg.agent}</div>
                  <div>{msg.firstname}</div>
                  <div>{msg.lastname}</div>
                  <div>{msg.gender}</div>
                  <div>{msg.age}</div>
                  <div>{msg["id/passport_no"]}</div>
                  <div>{msg.country}</div>
                  <div>{msg.nationality}</div>
                  <div>{msg.boat}</div>
                  <div>{msg.team}</div>
                  {/* <div>{msg.adl}</div> */}
                  {/* <div>{msg.chd}</div> */}
                  {/* <div>{msg.ift}</div> */}
                  {/* <div>{msg.voucher_no}</div> */}
                  {/* <div>{msg.hotel}</div> */}
                  <div>{msg.group_id}</div>
                  <div>{msg.checkin_no}</div>
                  <div>{msg.signature}</div>
                </div>
                {(filteredTable || table).map((el, index) => (
                  <RowCustomerListReport
                    key={index}
                    index={index + 1}
                    data={el}
                  />
                ))}
              </section>
            )}
            {_report_type === "register" && (
              <section className="table_container_register_report">
                <div className="table_header">
                  <div>{msg.no}</div>
                  <div>{msg.firstname}</div>
                  <div>{msg.lastname}</div>
                  <div>{msg.gender}</div>
                  <div>{msg.age}</div>
                  <div>{msg.adl}</div>
                  <div>{msg.chd}</div>
                  <div>{msg.ift}</div>
                  <div>{msg.agent}</div>
                  <div>{msg.group_id}</div>
                  <div>{msg.checkin_no}</div>
                  <div>{msg.signature}</div>
                </div>
                {(filteredTable || table).map((el, index) => (
                  <RowRegisterReport key={index} index={index + 1} data={el} />
                ))}
              </section>
            )}
            {_report_type === "insurance_report" && (
              <section className="table_container_insurance_report">
                <div className="table_header">
                  <div>{msg.no}</div>
                  <div>{msg.firstname}</div>
                  <div>{msg.lastname}</div>
                  <div>{msg.gender}</div>
                  <div>{msg.age}</div>
                  <div>{msg.adl}</div>
                  <div>{msg.chd}</div>
                  <div>{msg.ift}</div>
                  {/* <div>{msg.agent}</div> */}
                  {/* <div>{msg.group_id}</div> */}
                  <div>{msg.checkin_no}</div>
                  <div>{msg.signature}</div>
                </div>
                {(filteredTable || table).map((el, index) => (
                  <RowInsuranceReport key={index} index={index + 1} data={el} />
                ))}
              </section>
            )}
          </div>
        </div>
      </div>
      {AlertModal}
      {Toasts}
      {isLoadingOnTop && <LoadingOnTop />}
    </div>
  );
}

const RowCustomerListReport = ({ index, data }) => {
  const {
    no,
    agent,
    firstname,
    lastname,
    gender,
    age,
    id_passport_no,
    country,
    nationality,
    boat,
    team,
    adl,
    chd,
    ift,
    voucher_no,
    hotel,
    group_id,
    checkin_no,
    signature,
  } = data;
  return (
    <div className="table_content">
      <div>{no || "-"}</div>
      <div>{agent || "-"}</div>
      <div>{firstname || "-"}</div>
      <div>{lastname || "-"}</div>
      <div>{gender || "-"}</div>
      <div>{age || "-"}</div>
      <div>{id_passport_no || "-"}</div>
      <div>{country || "-"}</div>
      <div>{nationality || "-"}</div>
      <div>{boat || "-"}</div>
      <div>{team || "-"}</div>
      {/* <div>{adl||"-"}</div> */}
      {/* <div>{chd||"-"}</div> */}
      {/* <div>{ift||"-"}</div> */}
      {/* <div>{voucher_no||"-"}</div> */}
      {/* <div>{hotel||"-"}</div> */}
      <div>{group_id || "-"}</div>
      <div>{checkin_no || "-"}</div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {signature && (
          <div className="report-display-signature-container">
            <img
              style={{ height: 60 }}
              src={signature}
              alt={`signature ${firstname || ""} ${lastname || ""}`}
            />
            <div className="big-signature">
              <img
                src={signature}
                alt={`signature ${firstname || ""} ${lastname || ""}`}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const RowRegisterReport = ({ index, data }) => {
  const {
    no,
    agent,
    firstname,
    lastname,
    gender,
    age,
    id_passport_no,
    country,
    nationality,
    boat,
    adl,
    chd,
    ift,
    voucher_no,
    hotel,
    group_id,
    checkin_no,
    signature,
  } = data;
  return (
    <div className="table_content">
      <div>{no || "-"}</div>
      <div>{firstname || "-"}</div>
      <div>{lastname || "-"}</div>
      <div>{gender || "-"}</div>
      <div>{age || "-"}</div>
      <div>{adl || "-"}</div>
      <div>{chd || "-"}</div>
      <div>{ift || "-"}</div>
      <div>{agent || "-"}</div>
      <div>{group_id || "-"}</div>
      <div>{checkin_no || "-"}</div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {signature && (
          <div className="report-display-signature-container">
            <img
              style={{ height: 60 }}
              src={signature}
              alt={`signature ${firstname || ""} ${lastname || ""}`}
            />
            <div className="big-signature">
              <img
                src={signature}
                alt={`signature ${firstname || ""} ${lastname || ""}`}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const RowInsuranceReport = ({ index, data }) => {
  const {
    no,
    agent,
    firstname,
    lastname,
    gender,
    age,
    id_passport_no,
    country,
    nationality,
    boat,
    adl,
    chd,
    ift,
    voucher_no,
    hotel,
    group_id,
    checkin_no,
    signature,
  } = data;
  return (
    <div className="table_content">
      <div>{no || "-"}</div>
      <div>{firstname || "-"}</div>
      <div>{lastname || "-"}</div>
      <div>{gender || "-"}</div>
      <div>{age || "-"}</div>
      <div>{adl || "-"}</div>
      <div>{chd || "-"}</div>
      <div>{ift || "-"}</div>
      {/* <div>{agent || "-"}</div> */}
      {/* <div>{group_id || "-"}</div> */}
      <div>{checkin_no || "-"}</div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {signature && (
          <div className="report-display-signature-container">
            <img
              style={{ height: 60 }}
              src={signature}
              alt={`signature ${firstname || ""} ${lastname || ""}`}
            />
            <div className="big-signature">
              <img
                src={signature}
                alt={`signature ${firstname || ""} ${lastname || ""}`}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const prepareGeneratePdfCustomerListReport = async (msg, report) => {
  const headerTable = [
    msg.no,
    msg.agent,
    msg.first_name,
    msg.last_name,
    msg.gender,
    msg.age,
    msg["id/passport_no"],
    msg.country,
    msg.nationality,
    msg.boat,
    msg.team,
    msg.group_id,
    msg.checkin_no,
    msg.signature,
  ];

  let boatList = [];
  reduceRepeatElement(report, "id_boat").forEach((el) => {
    const boat = el.boat;
    const group = el.group_id.split("-")[0];
    boatList.push({ boat, group });
  });
  boatList = boatList.sort((a, b) => a.group.localeCompare(b.group)); // เรียงตาม group A-Z

  const dataset = [];

  for (const value of boatList) {
    const boat = value?.boat;

    const _report = report.filter((el) => el.boat === boat);
    let _table = convertReportToTableCustomerListReport(_report);
    // _table = await Promise.all(
    //   _table.map(async (element) => {
    //     let tempSignature = "";
    //     if (element?.signature_image_filepath) {
    //       const res = await fetchAuthPost(
    //         api.utils.getImageUriByImageUrlInGcs,
    //         {
    //           imageUrl: element?.signature_image_filepath,
    //         }
    //       );
    //       tempSignature = res.data;
    //     }
    //     return { ...element, signature: tempSignature };
    //   })
    // );
    const report_0 = _report[0];

    const subtitle1 = `${msg.tour_name}: ${report_0.tour_name}, ${report_0.trip_duration}`;
    const subtitle2 = `${msg.boat_name}: ${boat}`;
    let subtitle3;

    if (report_0.night) {
      const startDate = yyyymmddd_ddmmyyyy_v1(report_0.departure_date);
      const endDate = yyyymmddd_ddmmyyyy_v1(
        timeToYYYYMMDD(
          new Date(report_0.departure_date).getTime() +
            report_0.night * 24 * 60 * 60 * 1000
        )
      );
      subtitle3 = `${msg.date}: ${startDate} - ${endDate}`;
    } else {
      subtitle3 = `${msg.date}: ${yyyymmddd_ddmmyyyy_v1(_report[0].date)}`;
    }

    const bodyTable = await Promise.all(
      _table.map(async (el, index) => {
        const tempSignature =
          el?.signature && typeof el.signature === "string"
            ? await getImageWithAspectRatio(el.signature, 40)
            : "";
        const signature = {
          image: tempSignature.image,
          width: tempSignature.width,
          height: tempSignature.height,
          alignment: "center",
        };

        return [
          `${index + 1}.`,
          el?.agent || "-",
          el?.firstname || "-",
          el?.lastname || "-",
          el?.gender || "-",
          el?.age || "-",
          el?.id_passport_no || "-",
          el?.country || "-",
          el?.nationality || "-",
          el?.boat || "-",
          el?.team || "-",
          el?.group_id || "-",
          el?.checkin_no || "-",
          signature,
        ];
      })
    );

    dataset.push({
      title: msg.customer_list_report,
      subtitle1,
      subtitle2,
      subtitle3,
      headerTable,
      bodyTable,
      widths: [20, 45, 60, 60, 35, 20, 70, 50, 50, 45, 45, 45, 55, 70],
      widthForExcel: [5, 10, 10, 10, 8, 5, 18, 14, 14, 10, 10, 9, 12, 14],
      orgLogoPositionInExcel: 4,
    });
  }

  return dataset;
};

const prepareGeneratePdfRegister = async (msg, report) => {
  const headerTable = [
    msg.no,
    msg.first_name,
    msg.last_name,
    msg.gender,
    msg.age,
    msg.adl,
    msg.chd,
    msg.ift,
    msg.agent,
    msg.group_id,
    msg.checkin_no,
    msg.signature,
  ];

  let boatList = [];
  reduceRepeatElement(report, "id_boat").forEach((el) => {
    const boat = el.boat;
    const group = el.group_id.split("-")[0];
    boatList.push({ boat, group });
  });

  // Sort
  boatList = boatList.sort((a, b) => a.group.localeCompare(b.group));

  const dataset = [];
  for (const value of boatList) {
    const boat = value?.boat;
    const _report = report.filter((el) => el.boat === boat);
    let _table = convertReportToTableRegister(_report);
    // _table = await Promise.all(
    //   _table.map(async (element) => {
    //     let tempSignature = "";
    //     if (element?.signature_image_filepath) {
    //       const res = await fetchAuthPost(
    //         api.utils.getImageUriByImageUrlInGcs,
    //         {
    //           imageUrl: element?.signature_image_filepath,
    //         }
    //       );
    //       tempSignature = res.data;
    //     }
    //     return { ...element, signature: tempSignature };
    //   })
    // );
    const report_0 = _report[0];

    const subtitle1 = `${msg.tour_name}: ${report_0.tour_name}, ${report_0.trip_duration}`;
    const subtitle2 = `${msg.boat_name}: ${boat}`;
    let subtitle3;

    if (report_0.night) {
      const startDate = yyyymmddd_ddmmyyyy_v1(report_0.departure_date);
      const endDate = yyyymmddd_ddmmyyyy_v1(
        timeToYYYYMMDD(
          new Date(report_0.departure_date).getTime() +
            report_0.night * 24 * 60 * 60 * 1000
        )
      );
      subtitle3 = `${msg.date}: ${startDate} - ${endDate}`;
    } else {
      subtitle3 = `${msg.date}: ${yyyymmddd_ddmmyyyy_v1(_report[0].date)}`;
    }

    const bodyTable = await Promise.all(
      _table.map(async (el, index) => {
        const tempSignature =
          el?.signature && typeof el.signature === "string"
            ? await getImageWithAspectRatio(el.signature, 40)
            : "";
        const signature = {
          image: tempSignature.image,
          width: tempSignature.width,
          height: tempSignature.height,
          alignment: "center",
        };

        return [
          `${index + 1}.`,
          el?.firstname || "-",
          el?.lastname || "-",
          el?.gender || "-",
          el?.age || "-",
          el?.adl || "-",
          el?.chd || "-",
          el?.ift || "-",
          el?.agent || "-",
          el?.group_id || "-",
          el?.checkin_no || "-",
          signature,
        ];
      })
    );

    dataset.push({
      title: msg.register,
      subtitle1,
      subtitle2,
      subtitle3,
      headerTable,
      bodyTable,
      widths: [25, 90, 90, 45, 30, 30, 30, 30, 90, 50, 80, 90],
      widthForExcel: [5, 14, 14, 14, 8, 10, 10, 10, 14, 14, 14, 14],
      orgLogoPositionInExcel: 3.99,
    });
  }

  return dataset;
};

const prepareGeneratePdfInsuranceReport = async (msg, report) => {
  const headerTable = [
    msg.no,
    msg.first_name,
    msg.last_name,
    msg.gender,
    msg.age,
    msg.adl,
    msg.chd,
    msg.ift,
    msg.checkin_no,
    msg.signature,
  ];

  let boatList = [];
  reduceRepeatElement(report, "id_boat").forEach((el) => {
    const boat = el.boat;
    const group = el.group_id.split("-")[0];
    boatList.push({ boat, group });
  });

  // Sort
  boatList = boatList.sort((a, b) => a.group.localeCompare(b.group));

  const dataset = [];
  for (const value of boatList) {
    const boat = value?.boat;
    const _report = report.filter((el) => el.boat === boat);
    let _table = convertReportToTableInsuracneReport(_report);
    // _table = await Promise.all(
    //   _table.map(async (element) => {
    //     let tempSignature = "";
    //     if (element?.signature_image_filepath) {
    //       const res = await fetchAuthPost(
    //         api.utils.getImageUriByImageUrlInGcs,
    //         {
    //           imageUrl: element?.signature_image_filepath,
    //         }
    //       );
    //       tempSignature = res.data;
    //     }
    //     return { ...element, signature: tempSignature };
    //   })
    // );

    const report_0 = _report[0];

    const subtitle1 = `${msg.tour_name}: ${report_0.tour_name}, ${report_0.trip_duration}`;
    const subtitle2 = `${msg.boat_name}: ${boat}`;
    let subtitle3;

    if (report_0.night) {
      const startDate = yyyymmddd_ddmmyyyy_v1(report_0.departure_date);
      const endDate = yyyymmddd_ddmmyyyy_v1(
        timeToYYYYMMDD(
          new Date(report_0.departure_date).getTime() +
            report_0.night * 24 * 60 * 60 * 1000
        )
      );
      subtitle3 = `${msg.date}: ${startDate} - ${endDate}`;
    } else {
      subtitle3 = `${msg.date}: ${yyyymmddd_ddmmyyyy_v1(_report[0].date)}`;
    }

    const bodyTable = await Promise.all(
      _table.map(async (el, index) => {
        const tempSignature =
          el?.signature && typeof el.signature === "string"
            ? await getImageWithAspectRatio(el.signature, 40)
            : "";
        const signature = {
          image: tempSignature.image,
          width: tempSignature.width,
          height: tempSignature.height,
          alignment: "center",
        };

        return [
          `${index + 1}.`,
          el?.firstname || "-",
          el?.lastname || "-",
          el?.gender || "-",
          el?.age || "-",
          el?.adl || "-",
          el?.chd || "-",
          el?.ift || "-",
          el?.checkin_no || "-",
          signature,
        ];
      })
    );

    dataset.push({
      title: msg.insurance_report,
      subtitle1,
      subtitle2,
      subtitle3,
      headerTable,
      bodyTable,
      widths: [25, 100, 100, 65, 60, 60, 60, 60, 80, 90],
      widthForExcel: [5, 14, 14, 14, 8, 10, 10, 10, 14, 14],
      orgLogoPositionInExcel: 3.99,
    });
  }

  return dataset;
};

const loadFonts = async () => {
  pdfMake.vfs = {
    ...pdfMake.vfs,
    "Sarabun-Regular.ttf": base64.sarabun.regular,
    "Sarabun-Bold.ttf": base64.sarabun.bold,
    "Sarabun-Italic.ttf": base64.sarabun.italic,
    "Sarabun-BoldItalic.ttf": base64.sarabun.bold_italic,
  };

  pdfMake.fonts = {
    Sarabun: {
      normal: "Sarabun-Regular.ttf",
      bold: "Sarabun-Bold.ttf",
      italics: "Sarabun-Italic.ttf",
      bolditalics: "Sarabun-BoldItalic.ttf",
    },
  };
};

const buildContentSection = (
  headerTable,
  bodyTable,
  widths,
  removePageBreak = false
) => {
  const _header = headerTable.map((el) => ({
    text: el,
    style: "tableHeader",
  }));

  const _body = bodyTable.map((row) =>
    row.map((cell) =>
      typeof cell === "object" && cell.image
        ? cell
        : { text: cell, style: "normal" }
    )
  );

  let result = [
    {
      table: {
        headerRows: 1,
        widths: widths,
        body: [_header, ..._body],
      },
      layout: {
        hLineColor: () => "#dddddd",
        vLineColor: () => "#dddddd",
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5,
      },
    },
  ];
  if (removePageBreak === false) {
    result.push({ text: "", pageBreak: "after" });
  }
  return result;
};

const ButtonDownloadExcel = ({
  label = "ดาวน์โหลด Excel",
  bgBase64,
  reportType,
  reportData,
}) => {
  const { msg } = useSelector((s) => s.language);
  const { staticData } = useStaticData();
  const { allProvinceDistrictSubdistrictList, countryList } = staticData;
  const handleDownload = async () => {
    let dataset;
    let filename;
    if (reportType === "customer_list_report") {
      dataset = await prepareGeneratePdfCustomerListReport(msg, reportData);
      filename = `${msg.customer.toUpperCase()}_${timestampFilename()}`;
    } else if (reportType === "register") {
      dataset = await prepareGeneratePdfRegister(msg, reportData);
      filename = `${msg.register.toUpperCase()}_${timestampFilename()}`;
    } else if (reportType === "insurance_report") {
      dataset = await prepareGeneratePdfInsuranceReport(msg, reportData);
      filename = `${msg.insurance.toUpperCase()}_${timestampFilename()}`;
    }

    const tempData = await fetchAuthPost(api.report.readHeaderData);

    const { organization } = tempData.data;
    const { company } = tempData.data;

    let {
      organization_logo,
      organization_name_english: organization_name,
      address: organization_address,
      id_subdistrict,
      id_district,
      id_province,
      postal_code,
      id_country,
    } = organization;
    const {
      label_th_province,
      label_en_province,
      label_th_district,
      label_en_district,
      label_th_subdistrict,
      label_en_subdistrict,
    } = allProvinceDistrictSubdistrictList.find(
      (el) =>
        `${el.id_subdistrict}` === `${id_subdistrict}` &&
        `${el.id_district}` === `${id_district}` &&
        `${el.id_province}` === `${id_province}`
    );
    const label_province = label_en_province;
    const label_district = label_en_district;
    const label_subdistrict = label_en_subdistrict;

    const country = countryList.find(
      (el) => `${el.id_country}` === `${id_country}`
    );
    const { label_en: label_en_country, label_th: label_th_country } = country;
    const label_country = label_en_country;

    organization_name = `${msg.organization_name}: ${organization_name}`;
    organization_address = `${msg.address}: ${organization_address}, ${label_subdistrict}, ${label_district}, ${label_province} ${postal_code}, ${label_country}.`;
    organization_address = organization_address.replaceAll(",,", ",");

    let {
      phone_numer: company_phone_number,
      email: company_email,
      company_name_english: company_name,
      address: company_address,
    } = company;
    company_phone_number = `${msg.tel}: ${company_phone_number || "-"}`;
    company_email = `${msg.email}: ${company_email || "-"}`;

    const workbook = new ExcelJS.Workbook();
    for (let i = 0; i < dataset.length; i++) {
      const data = dataset[i];
      const {
        title,
        subtitle1,
        subtitle2,
        subtitle3,
        headerTable,
        bodyTable,
        widths,
        widthForExcel,
        orgLogoPositionInExcel,
      } = data;
      const worksheet = workbook.addWorksheet(subtitle2.split(":")[1]);

      widthForExcel.forEach((width, index) => {
        worksheet.getColumn(index + 1).width = width;
      });

      const logoId = workbook.addImage({
        base64: bgBase64,
        extension: "jpg",
      });
      const { width: originalWidthLogoId, height: originalHeightLogoId } =
        await getImageDimensions(bgBase64);
      const targetWidthLogoId = 240;
      const aspectRatioLogoId = originalWidthLogoId / originalHeightLogoId;
      const targetHeightLogoId = targetWidthLogoId / aspectRatioLogoId;
      worksheet.addImage(logoId, {
        tl: { col: 0, row: 0 + 0.4 },
        ext: { width: targetWidthLogoId, height: targetHeightLogoId },
      });

      // ✅ โลโก้องค์กรแบบรักษาสัดส่วน
      const orgLogoBase64 = organization_logo.split(",")[1];
      const { width: originalWidth, height: originalHeight } =
        await getImageDimensions(orgLogoBase64);
      const targetHeight = 52;
      const aspectRatio = originalWidth / originalHeight;
      const targetWidth = targetHeight * aspectRatio;

      const orgLogo = workbook.addImage({
        base64: orgLogoBase64,
        extension: "jpg",
      });

      worksheet.addImage(orgLogo, {
        tl: { col: orgLogoPositionInExcel, row: 0 },
        ext: {
          width: targetWidth,
          height: targetHeight,
        },
      });

      const _organizationNameCell = worksheet.getRow(5);
      const _organizationAddressCell = worksheet.getRow(6);
      const _companyPhoneNumberCell = worksheet.getRow(7);
      const _companyEmailCell = worksheet.getRow(8);
      const organizationNameCell = _organizationNameCell.getCell(1);
      const organizationAddressCell = _organizationAddressCell.getCell(1);
      const companyPhoneNumberCell = _companyPhoneNumberCell.getCell(1);
      const companyEmailCell = _companyEmailCell.getCell(1);
      organizationNameCell.value = organization_name;
      organizationAddressCell.value = organization_address;
      companyPhoneNumberCell.value = company_phone_number;
      companyEmailCell.value = company_email;

      const rightCol = headerTable.length;

      const _titleCell = worksheet.getRow(1);
      const _subtitle1Cell = worksheet.getRow(5);
      const _subtitle2Cell = worksheet.getRow(6);
      const _subtitle3Cell = worksheet.getRow(7);
      const titleCell = _titleCell.getCell(rightCol);
      const subtitle1Cell = _subtitle1Cell.getCell(rightCol);
      const subtitle2Cell = _subtitle2Cell.getCell(rightCol);
      const subtitle3Cell = _subtitle3Cell.getCell(rightCol);

      titleCell.value = title;
      titleCell.font = { bold: true };
      subtitle1Cell.value = subtitle1;
      subtitle2Cell.value = subtitle2;
      subtitle3Cell.value = subtitle3;

      titleCell.alignment = {
        horizontal: "right",
        vertical: "middle",
      };
      subtitle1Cell.alignment = {
        horizontal: "right",
        vertical: "middle",
      };
      subtitle2Cell.alignment = {
        horizontal: "right",
        vertical: "middle",
      };
      subtitle3Cell.alignment = {
        horizontal: "right",
        vertical: "middle",
      };

      const headerRow = worksheet.getRow(9);
      headerRow.values = headerTable;
      headerRow.eachCell((cell, index) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "00397d" },
        };
        cell.font = { color: { argb: "FFFFFFFF" }, bold: true };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      for (let rowIndex = 0; rowIndex < bodyTable.length; rowIndex++) {
        const row = bodyTable[rowIndex];
        const tempRow = worksheet.getRow(rowIndex + 10);
        tempRow.height = 32; // เพิ่มความสูงแถวเผื่อรูป

        for (let colIndex = 0; colIndex < row.length; colIndex++) {
          const cellData = row[colIndex];

          const col = colIndex + 1;
          const cell = tempRow.getCell(col);

          if (typeof cellData === "object") {
            if (cellData.image) {
              // ถ้าเป็นรูป
              const imageBase64 = cellData.image.split(",")[1]; // ตัด prefix
              const { width: originalWidth, height: originalHeight } =
                await getImageDimensions(imageBase64);
              const targetHeight = 36;
              const aspectRatio = originalWidth / originalHeight;
              const targetWidth = targetHeight * aspectRatio;

              const imageId = workbook.addImage({
                base64: imageBase64,
                extension: "png",
              });

              worksheet.addImage(imageId, {
                tl: { col: colIndex, row: rowIndex + 9 + 0.1 }, // +9 เพราะเริ่มที่ row 10
                ext: {
                  width: targetWidth,
                  height: targetHeight,
                },
                editAs: "oneCell",
              });
            } else {
              cell.value = "";
            }
          } else {
            // ถ้าเป็นค่าธรรมดา
            cell.value = cellData;
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
            };
          }
          cell.border = {
            bottom: { style: "thin", color: { argb: "bbbbbb" } },
          };
        }
      }
    }

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${filename}.xlsx`);
  };

  return <button onClick={handleDownload}>{label}</button>;
};

function createPdfMakeDoc(data) {
  const cloneData = JSON.parse(JSON.stringify(data));
  const {
    organization_logo,
    organization_name,
    organization_address,
    company_phone_number,
    company_email,
    title,
    subtitle1,
    subtitle2,
    subtitle3,
    bgBase64,
    headerTable,
    bodyTable,
    widths,
  } = cloneData;
  return {
    pageOrientation: "landscape",
    pageSize: "A4",
    background: function (currentPage, pageSize) {
      return {
        image: `data:image/jpeg;base64,${bgBase64}`,
        width: pageSize.width,
        height: pageSize.height,
      };
    },
    pageMargins: [30, 180, 30, 75],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 5],
      },
      normal: {
        fontSize: 14,
        alignment: "center",
      },
      tableHeader: {
        fillColor: "#00397d",
        color: "#fff",
        bold: true,
        fontSize: 14,
        alignment: "center",
      },
    },
    defaultStyle: {
      font: "Sarabun",
    },

    content: buildContentSection(headerTable, bodyTable, widths, true),
    header: (currentPage, pageCount) => ({
      margin: [30, 30, 30, 30],
      fontSize: 14,
      stack: [
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 40,
              lineWidth: 2,
              lineColor: "#00397d",
            },
          ],
          absolutePosition: { x: 250, y: 30 },
        },
        {
          columns: [
            {
              image: organization_logo,
              fit: [55, 100],
              margin: [240, 0, 0, 0],
            },
            {
              text: title,
              alignment: "right",
              fontSize: 32,
              bold: true,
            },
          ],
        },
        {
          columns: [
            {
              text: "\n",
            },
          ],
        },
        {
          columns: [
            {
              text: `${organization_name || "-"}`,
              alignment: "left",
            },
            {
              text: `${subtitle1 || "-"}`,
              alignment: "right",
            },
          ],
        },
        {
          columns: [
            {
              text: `${organization_address || "-"}`,
              alignment: "left",
            },
            {
              text: `${subtitle2 || "-"}`,
              alignment: "right",
            },
          ],
        },
        {
          columns: [
            {
              text: `${company_phone_number || "-"}`,
              alignment: "left",
            },
            {
              text: `${subtitle3 || "-"}`,
              alignment: "right",
            },
          ],
        },
        {
          text: `${company_email || "-"}`,
        },
      ],
    }),
  };
}

function getPdfBlobFromPdfMake(docDefinition) {
  return new Promise((resolve) => {
    pdfMake.createPdf(docDefinition).getBuffer((buffer) => {
      resolve(buffer);
    });
  });
}

async function mergeAndAddFooters(
  pdfBuffers,
  prefixFooterLine1,
  prefixFooterLine2
) {
  const mergedPdf = await PDFDocument.create();
  mergedPdf.registerFontkit(fontkit);
  const fontBytes = base64ToUint8Array(base64.sarabun.regular);
  const font = await mergedPdf.embedFont(fontBytes);

  let totalPageCount = 0;
  const copiedPages = [];

  for (const pdfBytes of pdfBuffers) {
    const srcPdf = await PDFDocument.load(pdfBytes);
    const srcPages = await mergedPdf.copyPages(srcPdf, srcPdf.getPageIndices());
    copiedPages.push(...srcPages);
    totalPageCount += srcPages.length;
  }

  copiedPages.forEach((page, idx) => {
    mergedPdf.addPage(page);

    const { width, height } = page.getSize();
    const fontSize = 12;

    const line1 = prefixFooterLine1;
    const line2 = `${prefixFooterLine2} (${idx + 1}/${totalPageCount})`;

    const textWidth1 = font.widthOfTextAtSize(line1, fontSize);
    const textWidth2 = font.widthOfTextAtSize(line2, fontSize);

    const x1 = (width - textWidth1) / 2;
    const x2 = (width - textWidth2) / 2;

    page.drawText(line1, {
      x: x1,
      y: 30,
      size: fontSize,
      font,
      color: rgb(0.5, 0.5, 0.5),
    });

    page.drawText(line2, {
      x: x2,
      y: 15,
      size: fontSize,
      font,
      color: rgb(0.5, 0.5, 0.5),
    });
  });

  return await mergedPdf.save();
}

const ButtonDownloadPdf = ({ reportType, reportData }) => {
  const { msg } = useSelector((s) => s.language);
  const { staticData } = useStaticData();
  const { allProvinceDistrictSubdistrictList, countryList } = staticData;

  const onDownload = async () => {
    let dataset;
    let filename;
    if (reportType === "customer_list_report") {
      dataset = await prepareGeneratePdfCustomerListReport(msg, reportData);
      filename = `${msg.customer.toUpperCase()}_${timestampFilename()}`;
    } else if (reportType === "register") {
      dataset = await prepareGeneratePdfRegister(msg, reportData);
      filename = `${msg.register.toUpperCase()}_${timestampFilename()}`;
    } else if (reportType === "insurance_report") {
      dataset = await prepareGeneratePdfInsuranceReport(msg, reportData);
      filename = `${msg.insurance.toUpperCase()}_${timestampFilename()}`;
    }

    const tempData = await fetchAuthPost(api.report.readHeaderData);

    const { organization } = tempData.data;
    const { company } = tempData.data;

    let {
      organization_logo,
      organization_name_english: organization_name,
      address: organization_address,
      id_subdistrict,
      id_district,
      id_province,
      postal_code,
      id_country,
    } = organization;
    const {
      label_th_province,
      label_en_province,
      label_th_district,
      label_en_district,
      label_th_subdistrict,
      label_en_subdistrict,
    } = allProvinceDistrictSubdistrictList.find(
      (el) =>
        `${el.id_subdistrict}` === `${id_subdistrict}` &&
        `${el.id_district}` === `${id_district}` &&
        `${el.id_province}` === `${id_province}`
    );
    const label_province = label_en_province;
    const label_district = label_en_district;
    const label_subdistrict = label_en_subdistrict;

    const country = countryList.find(
      (el) => `${el.id_country}` === `${id_country}`
    );
    const { label_en: label_en_country, label_th: label_th_country } = country;
    const label_country = label_en_country;

    organization_name = `${msg.organization_name}: ${organization_name}`;
    let temp_company_address = `${organization_address}, ${label_subdistrict}, ${label_district}, ${label_province} ${postal_code}, ${label_country}.`;
    temp_company_address = temp_company_address.replaceAll(",,", ",");
    organization_address = `${msg.address}: ${temp_company_address}`;

    let {
      phone_numer: company_phone_number,
      email: company_email,
      company_name_english: company_name,
      address: company_address,
    } = company;
    company_phone_number = `${msg.tel}: ${company_phone_number || "-"}`;
    company_email = `${msg.email}: ${company_email || "-"}`;
    company_address = temp_company_address;
    const prefixFooterLine1 = `${company_name || "-"} ${
      company_address || "-"
    }`;
    const prefixFooterLine2 = `${msg.copyright || "-"}`;

    await loadFonts();
    const buffs = [];
    for (let i = 0; i < dataset.length; i++) {
      let element = dataset[i];
      element = {
        ...element,
        organization_logo,
        organization_name,
        organization_address,
        company_phone_number,
        company_email,
        bgBase64: base64.bgDoc,
      };
      const doc = createPdfMakeDoc(element);
      const buff = await getPdfBlobFromPdfMake(doc);
      buffs.push(buff);
    }

    const mergedPdfBytes = await mergeAndAddFooters(
      buffs,
      prefixFooterLine1,
      prefixFooterLine2
    );
    const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
    saveAs(blob, `${filename}.pdf`);
  };

  return <button onClick={onDownload}>{msg.pdf}</button>;
};
